<div style="padding:5px 20px;">
  <h1>{{'change_log'| translation}}</h1>
  <h3>{{'release_notes'| translation}}</h3>
  <div>
    <div class="change-log-entry" *ngFor="let change of changes">
      <div class="change-log-label">
        <div class="change-log-release">{{'release' | translation}} - {{change.data | localizeDate | date:'MMM d, yyyy'}}</div>
      </div>
      <ul class="change-log-details">
        <li *ngFor="let entry of change.items" class="change-log-items">
          <p>{{entry.content}}</p>
        </li>
      </ul>
    </div>
  </div>
  
</div>
